export default __webpack_public_path__ + "static/media/RINA.461aafde.jpg";